import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import * as React from 'react';
import * as Yup from 'yup';

import Layout from '@/components/layout/Layout';
import WaitlistProfileForm from '@/components/old/WaitlistProfileForm';

const WaitlistPage: React.FC<any> = () => {
  const router = useRouter();
  const email = router.query.e as string;

  // Check if email is valid
  let valid = true;
  try {
    Yup.string().email().validateSync(email);
  } catch (error) {
    valid = false;
  }

  // After submitting the form, redirect to Calendly
  const onSubmit = (data: any) => {
    if (
      data.creator_type == 'agency' ||
      data.audience_size == 'medium' ||
      data.audience_size == 'large'
    ) {
      router.push(
        `https://calendly.com/clipfm/20-min-demo-clip-fm?email=${data.email}&name=${data.name}`
      );
    }
  };

  return (
    <>
      <NextSeo title='Get started' />
      <Layout mode='light'>
        <main>
          <section className='mx-auto max-w-screen-md space-y-4 px-4 py-24 text-center'>
            <h1>
              Get a demo of <strong>clip.fm</strong>
            </h1>
            <p className='max-w-screen-lg px-12 text-xl'>
              We're opening up our AI clip generator to a limited number of
              creators. Fill out this form to get started.
            </p>
            <WaitlistProfileForm
              email={valid ? email : ''}
              onSubmit={onSubmit}
              submitButtonText={<>Continue &rarr;</>}
            />
          </section>
        </main>
      </Layout>
    </>
  );
};

export default WaitlistPage;
